import { isPlatformBrowser } from '@angular/common';
import { inject, Pipe, PipeTransform, PLATFORM_ID } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
    name: 'safeHtml',
    standalone: true,
})
export class SafeHtmlPipe implements PipeTransform {
    readonly platformId = inject(PLATFORM_ID);

    constructor(private sanitizer: DomSanitizer) {}

    private decodeHtml(html: string): string {
        const txt = document.createElement('textarea');
        txt.innerHTML = html;
        return txt.value;
    }

    private removeImgTags(html: string): string {
        return html.replace(/<img[\s\S]*?>/gi, '');
    }

    /**
     * @name transform
     * @description Transforms the input HTML by decoding it and optionally removing image tags.
     * @param html The HTML string to transform.
     * @param stripImages Whether to remove image tags from the HTML.
     * @returns The transformed HTML as a SafeHtml object.
     */
    transform(html: string, stripImages: boolean = false): SafeHtml {
        if (!isPlatformBrowser(this.platformId)) return '';

        let decodedHtml = this.decodeHtml(html);
        if (stripImages) {
            decodedHtml = this.removeImgTags(decodedHtml);
        }

        return this.sanitizer.bypassSecurityTrustHtml(decodedHtml);
    }
}
